<template>
  <div class="home">
    <div class="banner-wrap banner1">
      <div class="content">
        <h1>结构抗震性能设计软件PBSD</h1>
        <p style="text-align: left; max-width: 500px">
          提供全套超限分析解决方案及优质技术服务，辅助工程师高效完成超限分析，协助研究人员开展抗震课题研究。
        </p>
        <!-- <div style="text-align: left">
          <button class="pr-btn" @click="download">下载 PBSD 1.0</button>
        </div> -->
        <br />
        <div style="text-align: left; height: 000px">
          <button class="pr-btn more-btn" @click="download">软件下载</button
          >&nbsp;&nbsp;&nbsp;
          <button
            class="pr-btn more-btn"
            @click="goUrl('http://help.gwforu.com')"
          >
            用户手册</button>
          &nbsp;&nbsp;&nbsp;
          <button
            class="pr-btn more-btn"
            @click="goUrl('https://help.gwforu.com/PBSD/General/4efd')"
          >
            教学视频
          </button>
        </div>
      </div>
      <div class="imgContent">
        <img src="@/assets/computer.png" />
      </div>
    </div>

    <!-- 产品优势 -->
    <Advantage id="advantages" />
    <!-- 产品报价 -->
    <Price id="price" />
    <!-- 工程应用 -->
    <EngineeringApplication id="engineeringApplication" />
    <!-- 研发团队 -->
    <Team id="team" />
    <!-- 公司简介 -->
    <Introduction id="intro" />
    <!-- 回到顶部按钮 -->
    <back-to-top
      :visibility-height="300"
      :back-position="0"
      transition-name="fade"
    />
  </div>
</template>
<script>
import Advantage from '@/components/Advantage.vue'
import Price from '@/components/Price.vue'
import Introduction from '@/components/Introduction_2.vue'
import Article from '@/components/Article.vue'
//import intro from '@/md/intro.md'
import BackToTop from '@/components/BackToTop'
import ENV from '@/config/env.config'

import EngineeringApplication from '@/components/EngineeringApplication'
import Team from '@/components/Team.vue'

export default {
  name: 'home',
  components: {
    Advantage,
    Price,
    Introduction,
    //Article,
    BackToTop,
    EngineeringApplication,
    Team,
  },
  methods: {
    getProducts() {
      this.$store.dispatch('GetProducts')
    },
    getScanToken() {
      let params = {
        code: this.$route.query.code,
        state: this.$route.query.state || '123456', // todo: random
      }
      this.$store
        .dispatch('ScanLogin', params)
        .then((res) => {
          this.getProducts()
        })
        .catch((err) => {
          if (err.ErrorCode === '1101') {
            // 当前账号未完成绑定
            this.$router.push({ path: '/login/bind-phone' })
          }
        })
    },
    download() {
      window.location.href = ENV.wwwURL + this.$store.getters.downloadUrl
    },
    goUrl(url) {
      window.open(url) //新窗口
      //window.location.href = url//当前页
      //this.$router.push({ path: '/' })
    },
  },
  created() {
    if (this.$route.query.code) {
      this.getScanToken()
    } else {
      this.getProducts()
    }
  },
}
</script>
<style lang="less" scoped>
.banner-wrap {
  background-color: #5670b7;
  background-image: url('../assets/bg2.png');
  min-height: 400px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-attachment: fixed;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px; /* 上右下左 */
  font-family: 'Microsoft YaHei';
}
.banner1 {
  .content {
    max-width: 600px;
    margin-top: 20px;
  }
  .imgContent {
    padding: 0px 0px 0px 60px; /* 上右下左 */
    img {
      width: 350px;
    }
  }
  h1 {
    font-size: 30px;
    line-height: 42px;
    padding-bottom: 25px;
    text-align: left;
  }
  p {
    font-size: 16px;
    line-height: 26px;
    padding-bottom: 30px;
  }
}
.pr-btn {
  padding: 7px 40px;
  font-size: 20px;
  font-weight: 600;
  text-align: left;
}
.more-btn {
  padding: 10px 40px;
  font-size: 20px;
  font-weight: 600;
  font-family: 'Microsoft YaHei';
  margin-bottom: 15px;

  // background: #d5d8e0;
  // border-radius: 0px;
  // color: #414bd3;
  // border: none;
  // cursor: pointer;
}

@media screen and (max-width: 990px) {
  .banner-wrap {
  min-height: 280px;
  align-items: stretch;
}
  .banner1 {
    .content {
      max-width: 600px;
          margin-top: 0px;
    }
    .imgContent {
      padding: 0px;
      visibility: hidden;
      img {
        width: 0px;
      }
    }
    h1 {
      font-size: 25px;
      line-height: 50px;
      padding-bottom: 8px;
    }
    p {
      font-size: 14px;
      line-height: 20px;
      padding-bottom: 20px;
    }
  }
}
</style>

